import React, { Component } from "react";
import Logo from "../assets/images/bootstrap-solid.svg";
import { Link } from "react-router-dom";

class Setting extends Component {
    render() {
        return <React.Fragment>

            <div className="album">
                <div className="container mt-45">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-body text-center">
                                    <img src={Logo} alt="Kathy Davis" className="img-fluid rounded-circle mb-2" width="128" height="128" />
                                    <h4 className="card-title mb-2">Niochi v1.0</h4>
                                    <div className="text-muted mb-2">
                                        <p>
                                            Niochi est l'application qui vous permet d'accéder aux informations sur les établissements commerciaux et de trouver le bon endroit correspondant à vos attentes.
                            </p>
                                    </div>
                                    <table className="table table-condensed text-left">
                                        <tbody>
                                            <tr className="row">
                                                <th className="col-4">Numéro de téléphone :</th>
                                                <th className="col-8"><a href="tel:+242 06 695 92 57">+242 06 695 92 57</a> <br /> <a href="tel:+242 05 304 58 68">+242 05 304 58 68</a> </th>
                                            </tr>
                                            <tr className="row">
                                                <th className="col-4">E-mail :</th>
                                                <th className="col-8"><a href="mailto:mbote@niochi.com">mbote@niochi.com</a></th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div>
                                        <a className="btn btn-primary btn-sm" href="https://forms.gle/HPdbPmb4x1RyeDFP6">Donner votre avis !</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">

                            <div className="list-group mt-4">
                                <button type="button" className="list-group-item list-group-item-action active">Profile</button>
                                <button type="button" className="list-group-item list-group-item-action">
                                    <Link to={"/profile"}>
                                        Se connecter / s'inscrire
                                    </Link>
                                    <span className="float-right">
                                        <i className="fas fa-user"></i>
                                    </span>
                                </button>

                               
                            </div>
                            <div className="list-group mt-4">
                                <button type="button" className="list-group-item list-group-item-action active">Liens utiles</button>
                                <button type="button" className="list-group-item list-group-item-action">
                                    <Link to={"/"}>
                                        Accueil
                                    </Link>
                                    <span className="float-right">
                                        <i className="fas fa-home"></i>
                                    </span>
                                </button>
                                <button type="button" className="list-group-item list-group-item-action">
                                    <a href="https://forms.gle/HPdbPmb4x1RyeDFP6">Votre avis de Niochi</a>
                                    <span className="float-right">
                                        <i className="fas fa-edit"></i>
                                    </span>
                                </button>
                                <button type="button" className="list-group-item list-group-item-action">

                                    <Link to={"/job"}>
                                        Carrière
                                    </Link>
                                    <span className="float-right">
                                        <i className="fas fa-briefcase"></i>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}

export default Setting;